class UndefinedStoreVariableError extends Error {
  constructor(variableName) {
    const message = `Store's ${variableName} variable is undefined. Please ensure \
      you've started the component with connect(mapStateToProps, mapDispatchToProps).`;
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default UndefinedStoreVariableError;
